import React from "react";
import type { VerticalNavigationPageArea } from "~/routing/VerticalNavigationPageAreaContext";
export interface UpdateGlobalPageDetailsProviderProps {
    value: UpdateGlobalPageDetailsCallback;
    children: React.ReactNode;
}
export function UpdateGlobalPageDetailsProvider({ value, children }: UpdateGlobalPageDetailsProviderProps) {
    return <UpdateGlobalPageDetailsContext.Provider value={value}>{children}</UpdateGlobalPageDetailsContext.Provider>;
}
export function useUpdateGlobalPageDetails() {
    const updateGlobalPageDetails = React.useContext(UpdateGlobalPageDetailsContext);
    if (!updateGlobalPageDetails) {
        throw new Error("The UpdateGlobalPageDetailsContext has not been set up. Please check the component hierarchy and ensure the appropriate context exists above this component.");
    }
    return updateGlobalPageDetails;
}
export interface GlobalPageDetails {
    pageId: string;
    pageArea: string;
    pageName: string;
    pageInstanceId: string;
    routeParams: Record<string, string>;
    routeTemplate: string;
    owner: string;
    verticalNavigationPageArea: VerticalNavigationPageArea;
}
export type UpdateGlobalPageDetailsCallback = (pageDetails: GlobalPageDetails) => void;
const UpdateGlobalPageDetailsContext = React.createContext<UpdateGlobalPageDetailsCallback | undefined>(undefined);
